var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.9439C21.0034 13.2637 20.6951 14.5658 20.1 15.7439C19.3944 17.1556 18.3098 18.343 16.9674 19.1732C15.6251 20.0033 14.0782 20.4433 12.5 20.4439C11.1801 20.4473 9.87812 20.1389 8.7 19.5439L3 21.4439L4.9 15.7439C4.30493 14.5658 3.99656 13.2637 4 11.9439C4.00061 10.3656 4.44061 8.81873 5.27072 7.47643C6.10083 6.13413 7.28825 5.04944 8.7 4.34388C9.87812 3.74881 11.1801 3.44043 12.5 3.44388H13C15.0843 3.55887 17.053 4.43864 18.5291 5.91474C20.0052 7.39083 20.885 9.35953 21 11.4439V11.9439Z",
    stroke: "#041967",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesPrimary);
export default __webpack_public_path__ + "static/media/messages_primary.dab8d5e4c31a3de5631ba51db1a155a0.svg";
export { ForwardRef as ReactComponent };